<template>
    <b-form :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}" @failure="formFailure"
            :save-params="{api_key: currentUser.api_key}" :initial-data="initialData">

        <div class="row">
            <validated-input class="col-12" label="Name" v-model="model.name"
                             :rules="rules.name" :disabled="loading"/>
        </div>

        <div class="row">
            <validated-input class="col-6" label="Place" v-model="model.place"
                             :rules="rules.place" :disabled="loading"/>

                      <div class="file-upload-wrapper col-6">
    <label class="field-label">Profile Image</label>

    <div
        class="custom-file-input"
        @click="triggerFileInput(loading)"
    >
        <span>
    {{
        model.profile_img
            ? (model.profile_img.name || model.profile_img.split('/').pop())
            : 'Browse'
    }}
</span>
    </div>

    <input
        ref="fileInput"
        type="file"
        class="hidden-file-input"
        accept="image/*"
        :disabled="loading"
        @change="handleFileChange($event, model)"
    />
</div>
        </div>
        <div class="row">
            <div class="col">
                <image-info :width="380" :height="380"/>
            </div>
        </div>

        <div class="row">
            <validated-input class="col-12" label="Comment" type="text" v-model="model.comment" size="150"
                             :rules="rules.comment" :disabled="loading"/>
        </div>

        <btn class="trn" size="sm" :loading="loading" color="primary" text="Update"
             loading-text="Updating..." :disabled="loading"/>
    </b-form>
</template>

<script>
import urls from '../../../../data/urls';
import { mapGetters } from 'vuex';

export default {
    name     : 'EditTestimonials',
    props    : { initialData : { type : Object } },
    computed : { ...mapGetters(['currentUser']) },
    data () {
        return {
            addUrl : urls.admin.event.testimonials.addEdit,
            rules  : {
                name : {
                    required : true
                },
                place : {
                    required : true
                },
                profile_img : {
                    required : true
                },
                comment : {
                    max      : 210,
                    min      : 200,
                    required : true
                }
            }
        };
    },

    methods : {
        triggerFileInput (loading) {
            if (!loading) {
                this.$refs.fileInput.click();
            }
        },
        viewFile (url) {
            window.open(url);
        },
        handleFileChange (event, model) {
            const file = event.target.files && event.target.files[0];

            if (!file) {
                return;
            }

            const image = new Image();

            image.onload = () => {
                if (image.width !== 380 || image.height !== 380) {
                    this.$notify(
                        'Please upload an image with dimensions 380 × 380 pixels.',
                        'Invalid Image',
                        {
                            type : 'warning'
                        }
                    );

                    event.target.value = '';
                    model.profile_img = null;

                    return;
                }

                this.$set(model, 'profile_img', file);
            };

            image.src = URL.createObjectURL(file);
        },
        formSuccess () {
            this.$notify('Successfully Edited Testimonial..!', 'Success',
                {
                    type : 'success'
                }
            );
            this.$emit('success');
        },

        formFailure (response) {
            const json = response.data;
            if (json.permission === false) {
                this.$notify('Invalid Authentication..!', 'Permission Denied',
                    {
                        type : 'warning'
                    }
                );
            }
        }
    }
};
</script>

<style scoped>
.hidden-file-input {
  display: none;
}
.custom-file-input {
  width: 100%;
  height: 38px;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  padding: 8px 10px;
  font-size: 14px;
  line-height: 1.5;
  display: flex;
  align-items: center;
  background-color: white;
  cursor: pointer;
  color:black;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
</style>
